var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIconV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    height: 12,
    rx: 1,
    transform: "rotate(-90 0 2)",
    width: 2,
    y: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIconV2);
export default __webpack_public_path__ + "static/media/minus_icon_v2.bac48a77ce6f19421b72acfb87853bc5.svg";
export { ForwardRef as ReactComponent };